export const TIER_LABELS = {
  1: 'Portfolio',
  2: 'Delivery Stream',
  3: 'Release Train',
  4: 'Team',
};

/**
 * Backend's meta.tier_labels is string-keyed (JSON object keys are always
 * strings), so this accepts either a number or a string tier and falls back
 * to the local TIER_LABELS constant, then to a generic "Tier N" label.
 */
export function getTierLabel(tier, tierLabels) {
  if (tierLabels) {
    const fromBackend = tierLabels[tier] ?? tierLabels[String(tier)];
    if (fromBackend != null) return fromBackend;
  }
  return TIER_LABELS[Number(tier)] ?? TIER_LABELS[tier] ?? `Tier ${tier}`;
}
